import "./App.css";
import "./styles/panel-theme.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Properties from "./pages/Properties";
import PropertyDetail from "./pages/PropertyDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ListProperty from "./pages/ListProperty";
import About from "./pages/About";
import Blog from "./pages/Blog";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Refund from "./pages/Refund";
import Cancellation from "./pages/Cancellation";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminPanel from "./pages/AdminPanel";
import SuperAdminPanel from "./pages/SuperAdminPanel";
import StaffPanel from "./pages/StaffPanel";
import Vendors from "./pages/Vendors";
import VendorDetail from "./pages/VendorDetail";
import VendorRegister from "./pages/VendorRegister";
import VendorDashboard from "./pages/VendorDashboard";
import FoodMenu from "./pages/FoodMenu";
import MyOrders from "./pages/MyOrders";
import Roommates from "./pages/Roommates";
import Messages from "./pages/Messages";
import StudentAmbassador from "./pages/StudentAmbassador";
import Laundry from "./pages/Laundry";
import OperatorDashboard from "./pages/OperatorDashboard";
import Maintenance from "./pages/Maintenance";
import Logout from "./pages/Logout";
import InvestorMetrics from "./pages/InvestorMetrics";
import BedInventory from "./pages/BedInventory";
import GuardPWA from "./pages/GuardPWA";
import TenantPWA from "./pages/TenantPWA";
import Pricing from "./pages/Pricing";
import HostroChatWidget from "./components/HostroChatWidget";
import { NewsletterPopup, ExitIntentPopup, OnboardingTour } from "./components/Engagement";

// Routes that should render full-bleed (no global Navbar, Footer, popups, chat widget).
const STANDALONE_ROUTES = ["/login", "/register", "/logout", "/metrics", "/investor", "/gate", "/t"];

function Shell() {
  const loc = useLocation();
  const standalone = STANDALONE_ROUTES.some((p) => loc.pathname === p || loc.pathname.startsWith(p + "/"));

  return (
    <>
      {!standalone && <Navbar />}
      <main className={standalone ? "" : "min-h-[60vh]"}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/:id" element={<PropertyDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/list-property" element={<ListProperty />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/cancellation" element={<Cancellation />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/super-admin" element={<SuperAdminPanel />} />
          <Route path="/staff" element={<StaffPanel />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/vendors/register" element={<VendorRegister />} />
          <Route path="/vendors/dashboard" element={<VendorDashboard />} />
          <Route path="/vendors/:id" element={<VendorDetail />} />
          <Route path="/food/:vendorId" element={<FoodMenu />} />
          <Route path="/orders" element={<MyOrders />} />
          <Route path="/roommates" element={<Roommates />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/student-ambassador" element={<StudentAmbassador />} />
          <Route path="/ambassador" element={<StudentAmbassador />} />
          <Route path="/laundry" element={<Laundry />} />
          <Route path="/operator" element={<OperatorDashboard />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/metrics" element={<InvestorMetrics />} />
          <Route path="/investor" element={<InvestorMetrics />} />
          <Route path="/pms/beds" element={<BedInventory />} />
          <Route path="/gate" element={<GuardPWA />} />
          <Route path="/t" element={<TenantPWA />} />
          <Route path="/pricing" element={<Pricing />} />
        </Routes>
      </main>
      {!standalone && <Footer />}
      {!standalone && <NewsletterPopup />}
      {!standalone && <ExitIntentPopup />}
      {!standalone && <OnboardingTour />}
      {!standalone && <HostroChatWidget />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                border: "2px solid #0F1F17",
                boxShadow: "4px 4px 0 0 #0F1F17",
                borderRadius: 0,
                fontFamily: "Outfit",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
